'use client';

import Image from 'next/image';
import { useTranslationDetector } from '@/hooks/useTranslationDetector';
import LandingCardItem from '../cards/LandingCardItem';
import { Button } from '@/components/ui/Button';

/**
 * Landing page hotel list component
 * @param {Object} props
 * @param {Array} props.hotels - Hotel data array
 */
export default function LandingHotelList({
  hotels = [],
  isFilterLoading = false,
  onSelectHotel,
  itemListId,
  itemListName,
  passengers,
  onClearFilters,
}) {
  const t = useTranslationDetector('hotel');

  if (!hotels || hotels.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-12 text-center">
        <Image src={"/images/svg/telescope.svg"} alt="No results" width={60} height={60} />
        <div>
          <p className="text-lg font-semibold text-foreground">
            {t('noHotelsFound')}
          </p>
          <p className="mt-2 text-sm text-foreground">
            {t('changeSearchCriteria')}
          </p>
          {onClearFilters && (
            <div className="mt-6">
              <Button className="w-[247px] h-[44px]" onClick={onClearFilters}>
                <span className="font-medium text-base leading-21 text-white">
                  {t('clearFilters')}
                </span>
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-4 ${isFilterLoading ? 'opacity-50' : ''}`}>
      {hotels.map((hotel, idx) => (
        <LandingCardItem
          key={hotel.id}
          hotelData={hotel}
          onSelect={() => onSelectHotel?.(hotel, idx + 1)}
          itemListId={itemListId}
          itemListName={itemListName}
          passengers={passengers}
        />
      ))}
    </div>
  );
}

